export default __webpack_public_path__ + "static/media/Discord.d5e3d3b0.svg";